export enum EncounterTypeEnum {
  Hospitalization = 'HOSPITALIZATION',
  Outpatient = 'OUTPATIENT',
}

export const ENCOUNTER_ROUTE = '/encounter';
export const ENCOUNTER_DOCUMENT_ROUTE = '/document';
export const ENCOUNTER_NAVIGATION_GROUP = 'ENCOUNTER_GROUP';
export const DOCUMENT_NAVIGATION_GROUP = 'DOCUMENT_GROUP'; // used for lab report
export const ENCOUNTER_REDUCER_STATE_ID = 'encounter';
